import React from 'react';

export const IconDefaultCheckbox = (
    <svg fill="none" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
        <rect fill="#fff" height="18.5" rx="3.25" stroke="#898991" width="18.5" x="2.75" y="2.75" />
    </svg>
);

export const IconDisabledCheckbox = (
    <svg fill="none" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
        <rect fill="#fff" height="18.5" rx="3.25" stroke="#E7E8EC" width="18.5" x="2.75" y="2.75" />
    </svg>
);

export const IconSelectedDisabledCheckbox = (
    <svg fill="none" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
        <rect fill="#E7E8EC" height="20" rx="4" width="20" x="2" y="2" />
        <path d="M17 9.5 10.5 16 7 12.5 8.5 11l2 2 5-5L17 9.5Z" fill="#fff" />
    </svg>
);

export const IconSelectedCheckbox = (
    <svg fill="none" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
        <rect fill="#EF3124" height="20" rx="4" width="20" x="2" y="2" />
        <path d="M17 9.5 10.5 16 7 12.5 8.5 11l2 2 5-5L17 9.5Z" fill="#fff" />
    </svg>
);
